// extracted by mini-css-extract-plugin
module.exports = {"CTA":"CTA_CTA__2at9n","BlobMagnet":"CTA_BlobMagnet__AMQXs","animate":"CTA_animate__2bzrX"};